export default __webpack_public_path__ + "static/travel-a8963fb76e77949cd6cb0b08894644e4.webp";